module.exports = __webpack_public_path__ + "h5/img/ggu_logo.91d7df58.png";